import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  ValidateURL,
  updatePasswordService,
  forgetPasswordService,
} from "../../utilities/partnerServices";
import { toast } from "react-toastify";
export const validateURL = createAsyncThunk("users/validateURL", ValidateURL);
export const updatePassService = createAsyncThunk(
  "users/updatePassService",
  updatePasswordService
);
export const forgetPasswordApi = createAsyncThunk(
  "users/forgetPassword",
  forgetPasswordService
);
const initialState = {
  passwordData: {
    responsCode: "",
    navigate: false,
    passwordUpdateSccess: false,
    loader: false,
  },
};
const updatePasswordSlice = createSlice({
  name: "registrations",
  initialState,
  reducers: {
    resetpasswordUpdate: (state) => {
      state.passwordData.loader = false
      state.passwordData.passwordUpdateSccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateURL.pending, (state, action) => {
        state.passwordData.loader = true;
      })
      .addCase(validateURL.fulfilled, (state, action) => {
        let responsCode = action.payload;

        if (responsCode.ResponseDetails.ResponseCode === "010") {
          state.passwordData.navigate = false;
        } else if (responsCode.ResponseDetails.ResponseCode === "D002") {
          state.passwordData.navigate = true;
          toast.error(responsCode.ResponseDetails.ResponseMessage);
        } else if (responsCode.ResponseDetails.ResponseCode === "D003") {
          state.passwordData.navigate = true;
          toast.error(responsCode.ResponseDetails.ResponseMessage);
        } else {
          toast.error(responsCode.ResponseDetails.ResponseMessage);
          state.passwordData.navigate = true;
        }
        state.passwordData.responsCode =
          responsCode.ResponseDetails.ResponseCode;      
        state.passwordData.loader = false;
      })
      .addCase(validateURL.rejected, (state, action) => {
        toast.error(action.error.message);
        state.passwordData.loader = false;
      })
      .addCase(updatePassService.pending, (state, action) => {
        state.passwordData.loader = true;
      })
      .addCase(updatePassService.fulfilled, (state, action) => {
        let responsCode = action.payload;
        if (responsCode.ResponseDetails.ResponseCode === "010") {
            state.passwordData.passwordUpdateSccess = true;
          }
        state.passwordData.loader = false;
      })

      .addCase(updatePassService.rejected, (state, action) => {
        toast.error(action.error.message);
        state.passwordData.loader = false;
      })
      .addCase(forgetPasswordApi.pending, (state, action) => {
        state.passwordData.loader = true;
      })
      .addCase(forgetPasswordApi.fulfilled, (state, action) => {
        let responsCode = action.payload;
        if (responsCode.ResponseDetails.ResponseCode === "010") {
            state.passwordData.passwordUpdateSccess = true;
          }else{
            toast.error(responsCode.ResponseDetails.ResponseMessage)
          }
        state.passwordData.loader = false;
      })

      .addCase(forgetPasswordApi.rejected, (state, action) => {
        toast.error(action.error.message);
        state.passwordData.loader = false;
      });
  },
});
export const { resetpasswordUpdate } = updatePasswordSlice.actions;
export default updatePasswordSlice.reducer;
